import i18next, { type i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LOCALES = ['en-US', 'de-DE', 'fr-FR', 'ja-JP', 'es-ES'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export type Translations = Record<string, unknown>;

export async function createI18n(locale: string, translations: Translations): Promise<i18n> {
	const instance = i18next.createInstance();

	await instance.use(initReactI18next).init({
		lng: locale,
		fallbackLng: 'en-US',
		resources: {
			[locale]: {
				common: translations,
			},
		},
		defaultNS: 'common',
		interpolation: {
			escapeValue: false,
		},
	});

	return instance;
}

/** @deprecated Use `createI18n` instead */
export const createServerI18n = createI18n;
/** @deprecated Use `createI18n` instead */
export const createClientI18n = createI18n;
